import { type ReactNode } from 'react'
import { AuthProvider as BaseAuthProvider } from '@betstarters/auth'
import api from '@/api/client'

// The frontend talks only to its own backend. Auth endpoints are proxied
// server-side to bs-iam via iamclient.
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <BaseAuthProvider config={{ api, enableImpersonation: false }}>
      {children}
    </BaseAuthProvider>
  )
}
